import React from 'react'
import PropTypes from 'prop-types'

import StarRating from 'components/StarRating'
import styles from './styles.scss'

const Review = (props) => {
  const {
    campaign: { address, suburb_name },
    review: { reviewer_name, rating, body },
  } = props

  return (
    <div className={styles.root}>
      <span className={styles.title}>{reviewer_name}</span>
      <span className={styles.address}>
        {address}, {suburb_name}
      </span>
      <span className={styles.rating}><StarRating value={rating} /></span>
      <span className={styles.body}>{body}</span>
    </div>
  )
}

Review.propTypes = {
  campaign: PropTypes.object.isRequired,
  review: PropTypes.object.isRequired,
}

export default Review
